import { client } from '../setup';
import { SingleQueryCreator, CriteriaCreator } from './base';
import { createAcceptedProperties } from '../helpers';

const acceptedReturnProperties = createAcceptedProperties(
  'id', 'name', 'management_address', 'hostname', 'public_address', 'offline_source'
);

const acceptedCriteriaProperties = {
  id: { type: 'string' },
};

class ApplianceCriteria extends CriteriaCreator {
  constructor(criteria = {}) {
    super(criteria);
  }
  get acceptedCriteria() {
    return acceptedCriteriaProperties;
  }
}

export class ApplianceQuery extends SingleQueryCreator {
  constructor() {
    super('appliance', ApplianceCriteria);
  }
  get acceptedReturnProperties() {
    return acceptedReturnProperties;
  }
}

export default {
  _appliance(applianceId) {
    const query = new ApplianceQuery();
    query.setId(applianceId);

    return {
      query,
      execute () {
        return client.query(query.name, query.toString());
      },
    };
  },
};